import * as React from 'react';
import BaseField from './BaseField';

class EntityField extends React.PureComponent {
    onChange = ({ field, value, fieldIndex }) => {
        const { onChange } = this.props;
        onChange &&
            this.handleEvent({
                field,
                fieldIndex,
                value,
                fieldHandler: field.onChangeHandler,
                formHandler: onChange
            });
    };

    onBlur = ({ field }) => {
        const { onBlur } = this.props;
        onBlur &&
            this.handleEvent({
                field,
                value: field.value,
                fieldHandler: field.onBlurHandler,
                formHandler: onBlur
            });
    };

    onDelete = ({ field, fieldIndex }) => {
        const { onChange } = this.props;
        onChange &&
            this.handleEvent({
                field,
                fieldIndex,
                fieldHandler: field.onDeleteHandler,
                formHandler: onChange
            });
    };

    handleEvent = ({ field, value, fieldIndex, fieldHandler, formHandler }) => {
        const { entity } = this.props;
        const updatedField = { ...field };

        let updatedEntity = null;
        if (fieldHandler) {
            updatedEntity = fieldHandler({
                field: updatedField,
                fieldIndex,
                entity,
                value
            });
        } else {
            updatedEntity = entity.setIn(updatedField.absoluteAccessor, value);
        }

        formHandler &&
            formHandler({
                field: updatedField,
                entity: updatedEntity,
                value
            });
    };

    disabledOnEdit = ({ field }) => {
        const { entity } = this.props;
        return field.disabledOnEdit({ field, entity });
    };

    getFieldProps = ({ field }) => {
        const { entity, getMappedProps, isEditing, t } = this.props;

        const allProps = {};
        if (getMappedProps) {
            allProps.props = getMappedProps();
        }
        if (field.defaultProps) {
            allProps.fieldProps = {
                ...field.defaultProps({
                    field,
                    entity,
                    t,
                    props: allProps.props
                })
            };
        }
        if (field.extraProps) {
            allProps.fieldProps = {
                ...allProps.fieldProps,
                ...field.extraProps({
                    field,
                    entity,
                    isEditing,
                    t,
                    props: allProps.props
                })
            };
        }
        return allProps;
    };

    render() {
        const { theme, field, isEditing, t, entity, testId } = this.props;

        return (
            <BaseField
                t={t}
                field={field}
                isEditing={isEditing}
                theme={theme}
                className={theme.inputField}
                onChange={this.onChange}
                onBlur={this.onBlur}
                onDelete={this.onDelete}
                entity={entity}
                getFieldProps={this.getFieldProps}
                disabledOnEdit={this.disabledOnEdit}
                testId={testId}
            />
        );
    }
}

export default EntityField;
